import { useSetAtom } from 'jotai';

import { useGetRandomVinFromProdLazyQuery } from '../../../gql/generated/graphql';
import { devVinAtom } from './devToolbarAtoms';

const useGetRandomDevVin = () => {
  const setDevVin = useSetAtom(devVinAtom);

  return useGetRandomVinFromProdLazyQuery({
    fetchPolicy: 'network-only',
    onCompleted({ getRandomVin }) {
      setDevVin(getRandomVin ?? '');
    },
  });
};

export default useGetRandomDevVin;
